/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/shop-:shopId'>.
 * префикс-параметр, был '/shop-:shopId'
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import SmsLandingStore from '@routes/SmsLandingStore/component';
import { getQueryClient } from '../providers/query';
import { shopsQueryOptions } from '@queries/shops';

export const Route = createFileRoute('/shop-{$shopId}')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  /**
   * ЭТАП 2 — честный 404 несуществующего магазина.
   *
   * Как здесь устроено получение магазина: отдельного метода «получить
   * магазин по identify» у бэка НЕТ, страница ищет его перебором в общем
   * списке — `shops.find(shop => shop.identify === params.shopId)`
   * (routes/SmsLandingStore). Значит и проверка существования это тот же
   * поиск по ответу getShops; список всё равно нужен «Наши адреса», поэтому
   * ensureQueryData дедуплицируется с root-префетчем.
   *
   * ЧТО БЫЛО: у компонента есть ФОЛБЭК — если identify не найден, он берёт
   * магазин с id 142 и рисует ЕГО лендинг под чужим адресом. То есть любой
   * /shop-<что угодно> отдавал HTTP 200 с контентом флагманского магазина —
   * для поисковика это ещё и дубли одной страницы под бесконечным числом
   * адресов. Теперь прямой заход на неизвестный identify отдаёт 404.
   *
   * Фолбэк в компоненте НЕ трогаем: после этого loader'а он остаётся живым
   * только для клиентской навигации. Убирать ли его совсем — отдельное
   * решение.
   */
  loader: async ({ params }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    let data;
    try {
      data = await queryClient.ensureQueryData(shopsQueryOptions());
    } catch {
      // Сетевой сбой — это не «страницы нет»: отдаём страницу как раньше,
      // клиент повторит запрос сам
      return;
    }
    const isKnownShop = (data?.getShops ?? []).some(
      shop => shop?.identify === params.shopId
    );
    if (!isKnownShop) {
      throw notFound();
    }
  },
  component: () => (
    <CacheDataRoute component={SmsLandingStore} path='/shop-:shopId' />
  )
});
